import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useApolloClient } from '@apollo/client'
import { Layout } from 'antd'

import Header from 'components/Header'
import SideMenu from 'components/SideMenu'
import AuthContext from 'contexts/AuthContext'
import LayoutContext from 'contexts/LayoutContext'
import { usePasswordReminder } from 'hooks/usePasswordReminder'
import { TCustomLayoutProps } from './CustomLayout.types'
import { isMobile } from 'react-device-detect'

const { Content } = Layout

const CustomLayout = ({ children, headerCustomComponent }: TCustomLayoutProps) => {
  const { user } = useContext(AuthContext)
  const { sideBarWidth } = useContext(LayoutContext)
  const navigate = useNavigate()
  const client = useApolloClient()
  const passwordReminder = usePasswordReminder()

  // Trigger password reminder modal for eligible users
  useEffect(() => {
    if (passwordReminder.shouldShowModal && user?._id) {
      // Small delay to ensure layout is rendered and user context is stable
      const timer = setTimeout(() => {
        passwordReminder.openModal()
      }, 500) // Increased delay for better UX
      
      return () => clearTimeout(timer)
    }
  }, [passwordReminder, user?._id]) // Include user._id to trigger on login changes

  const handleLogout = async () => {
    await client.cache.reset()
    localStorage.removeItem('accessToken')
    // localStorage.clear()
    navigate('/')
  }

  return (
    <Layout hasSider>
      {!isMobile && <SideMenu />}
      <Layout className="site-layout" style={{ marginLeft: isMobile ? 0 : sideBarWidth, backgroundColor: '#f8f8f8' }}>
        <Header user={user} handleLogout={handleLogout} headerCustomComponent={headerCustomComponent} />
        {/* Note: top margin is calculated based on the height of the header + 24px */}
        <Content
          style={{
            margin: '104px 16px 0',
            overflow: 'initial',
            backgroundColor: '#f8f8f8',
          }}
        >
          <div style={{ padding: isMobile ? 0 : 24 }}>{children}</div>
        </Content>
      </Layout>
    </Layout>
  )
}

export default CustomLayout
